class IPDetectPopup extends HTMLElement {
    constructor() {
      super();

      this.modal = this.querySelector(this.getAttribute('data-id'));

      this.currentUrl = window.location.href.replace(/%20/g, ""); // remove all occurrences of %20; or space

      this.showInUrl = this.modal.getAttribute("data-show-in-url");
      this.linkCountries = JSON.parse(this.modal.getAttribute("data-link-countries"));
      this.countryLink = '';

      this.btnYes = this.querySelector(".btn-yes");
      this.btnNo = this.querySelector(".btn-no");
      this.btnClose = this.querySelector(".close");

      if (
        !localStorage.getItem("confirmation-popup-response") &&
        localStorage.getItem("confirmation-popup-response") != "yes"
      ) {
        // Check if the current URL is the same as the URL to show popup
        if (this.showInUrl && this.currentUrl == this.showInUrl || !this.showInUrl) {
          this.checkCountry();
        }
      }

      if(this.showInUrl == 'all'){
        if (
          typeof(this.getCookie("ca-confirmation-popup-response")) == null ||
          this.getCookie("ca-confirmation-popup-response") != "no"
        ) {
          // Check if the current URL is the same as the URL to show popup
          this.checkIfCanada();
        }

        this.btnYes.addEventListener("click", this.onYesIfCA.bind(this));
        this.btnNo.addEventListener("click", this.closePopupAndSetCookie.bind(this));
        this.btnClose.addEventListener("click", this.closePopupAndSetCookie.bind(this));
      }
      else{
        this.btnYes.addEventListener("click", this.onYes.bind(this));
        this.btnNo.addEventListener("click", this.onNo.bind(this));
        this.btnClose.addEventListener("click", this.closePopup.bind(this));
      }
    }

    setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    checkCountry() {
      fetch("https://pro.ip-api.com/json/?key=RHxbtSkBVb67k14&fields=countryCode")
        .then((response) => response.text())
        .then((text) => {
          const countryCode = JSON.parse(text).countryCode;
          const euCountryCodes = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB", "CH"]

          // Check if country code is in the list of countries to show popup
          if (this.linkCountries[countryCode]) {
            this.countryLink = this.linkCountries[countryCode];
            this.showPopup();
          }
          // Check if country code is in the list of EU countries
          else if (euCountryCodes.includes(countryCode)) {
            this.countryLink = this.linkCountries['EU'];
            this.showPopup();
          }
        })
        .catch((error) => console.error(error));
    }

    checkIfCanada() {
      fetch("https://pro.ip-api.com/json/?key=RHxbtSkBVb67k14&fields=countryCode")
        .then((response) => response.text())
        .then((text) => {
          const countryCode = JSON.parse(text).countryCode;
          if(countryCode == 'CA'){
            this.countryLink = this.linkCountries['CA'];
            this.showPopup();
          }
        })
        .catch((error) => console.error(error));
    }

    showPopup() {
      if (this.modal) {
        this.modal.classList.add("show");
        document.querySelector("body").style.overflow = "hidden";
      }
    }

    closePopup() {
      if (this.modal) {
        this.modal.classList.remove("show");
        document.querySelector("body").style.overflow = "auto";
      }
    }

    onYes(event) {
      localStorage.setItem("confirmation-popup-response", "yes");
      event.preventDefault();
      this.closePopup();
    }

    onYesIfCA(event) {
      event.preventDefault();
      window.location.assign(this.countryLink);
    }

    onNo(event) {
      event.preventDefault();
      window.location.assign(this.countryLink);
    }

    closePopupAndSetCookie(event){
      event.preventDefault();
      this.setCookie("ca-confirmation-popup-response", "no", 3);
      this.closePopup();
    }
  }

  customElements.define("ip-detect-popup", IPDetectPopup);